import React, {Component} from 'react';
import styles from "./guanli.module.css";
import {FILE_URL} from "../../util/constants";
import icDelete from "../../img/delete.png";
import closeIcon from "../../img/bt-close.png";
import defaultIcon from "../../img/bee.png";
import MyImg from "../myimg/myimg.jsx";

import icDel from '../../img/icon_delete.png';

const Guanli = props => (
    <div className={styles["modal-overlay"]}>
        <div className={styles["modal-content"]}>
            <div className={styles.titlebar}>
                <div className={styles["text-name"]}>
                    班级管理
                </div>

                <img
                    className={styles.close}
                    src={closeIcon}
                    onClick={props.onRequestClose}
                />
            </div>

            <div className={styles.title0}>我的班级</div>

            {props.kerenList.length>0?
                <div className={styles["list-warpper"]}>
                    {
                        props.kerenList.map((item,index) => {
                            return (
                                <div className={styles["list-item"]} >
                                    <div className={styles["xueyuan-selected"]}
                                    >
                                        {item.classname} {item.xueke_name}
                                    </div>

                                    <img className={styles["img-delete"]} src={icDel} onClick={props.clickNianji.bind(null,item.id,item.classname)}/>

                                </div>);
                        })
                    }
                </div>
            :<div className={styles["no-data"]}>暂无班级</div>}

            {/*<div className={styles["list-warpper"]}>*/}
                {/*{*/}
                    {/*props.kerenList.map((item,index) => {*/}
                        {/*return (*/}
                            {/*<div className={styles["list-item"]} onClick={props.clickNianji.bind(null,item.id,item.classname)}>*/}
                                {/*<div className={styles["xueyuan-selected"]}*/}
                                     {/*>*/}
                                    {/*{item.classname}*/}
                                {/*</div>*/}

                                {/*<img className={styles["img-delete"]} src={icDel}/>*/}

                            {/*</div>);*/}
                    {/*})*/}
                {/*}*/}
            {/*</div>*/}

            <div className={styles.title0}>添加班级</div>

            <div className={styles["div-add"]}>
                <div className={styles.divInput}>
                    <div className={styles.input2} onClick={props.openClassValue}>
                        <div
                            className={styles.title}>{props.nianji_name == '' ? '' : props.nianji_name}</div>
                        <div className={styles.arrow}></div>
                    </div>
                    <div id='option' className={
                        props.showNianji ? styles.list2 : styles.list}>
                        <ul className={styles.ul}>
                            {
                                props.nianjiList.map((item) => {
                                    return (
                                        <li className={styles.li}
                                            onClick={props.getClassValue.bind(null, item.nianji_code, item.nianji_name)}
                                            key={item.nianji_code}>{item.nianji_name}</li>);
                                })
                            }
                        </ul>
                    </div>
                </div>

                <div className={styles.divInput}>
                    <div className={styles.input2} onClick={props.openClassValue2}>
                        <div
                            className={styles.title}>{props.banji_name == '' ? '' : props.banji_name}</div>
                        <div className={styles.arrow}></div>
                    </div>
                    <div id='option' className={
                        props.showBanji ? styles.list2 : styles.list}>
                        <ul className={styles.ul}>
                            {
                                props.banjiList.map((item) => {
                                    return (
                                        <li className={styles.li}
                                            onClick={props.getClassValue2.bind(null, item.classcode, item.name)}
                                            key={item.classcode}>{item.name}</li>);
                                })
                            }
                        </ul>
                    </div>
                </div>

                <div className={styles.divInput}>
                    <div className={styles.input2} onClick={props.openClassValue3}>
                        <div
                            className={styles.title}>{props.xueke_name == '' ? '' : props.xueke_name}</div>
                        <div className={styles.arrow}></div>
                    </div>
                    <div id='option' className={
                        props.showXueke ? styles.list2 : styles.list}>
                        <ul className={styles.ul}>
                            {
                                props.xuekeList.map((item) => {
                                    return (
                                        <li className={styles.li}
                                            onClick={props.getClassValue3.bind(null, item.code,item.name)}
                                            key={item.code}>{item.name}</li>);
                                })
                            }
                        </ul>
                    </div>
                </div>

                <div className={(props.nianji_code==''||props.banji_code==''||props.xueke_code=='')?styles["bt-add-gray"]:styles["bt-add"]} onClick={props.addKeren}>添加</div>

            </div>
        </div>
    </div>
)

export default Guanli;
